import React, { useEffect, useRef } from "react";
import { images, landingIcons } from "helpers/images";
import { NavLink } from "react-router-dom";
import styles from "./styles.module.scss";
import "../../../assets/css/landingStyle.css";
export default function LandingHeaderComponent() {
  const menusRef = useRef([]);

  useEffect(() => {
    const menus = document.querySelectorAll(".menu");

    const handleClickOutside = (event) => {
      menus.forEach((menu) => {
        const dropdown = menu.querySelector(".menu-dropdown");
        if (dropdown && !menu.contains(event.target)) {
          dropdown.classList.add("hide-landing");
          menu.classList.remove("active");
        }
      });
    };

    const handleMenuClick = (event, menu) => {
      event.stopPropagation();

      const dropdown = menu.querySelector(".menu-dropdown");

      const isActive = menu.classList.contains("active");
      menus.forEach((otherMenu) => {
        otherMenu.classList.remove("active");
        const otherDropdown = otherMenu.querySelector(".menu-dropdown");
        if (otherDropdown) otherDropdown.classList.add("hide-landing");
      });

      if (!isActive) {
        menu.classList.add("active");
        if (dropdown) dropdown.classList.remove("hide-landing");
      }
    };

    menus.forEach((menu) => {
      menu.addEventListener("click", (e) => handleMenuClick(e, menu));
    });

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      menus.forEach((menu) => {
        menu.removeEventListener("click", (e) => handleMenuClick(e, menu));
      });
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <header className="wrapper-landing">
        <nav id="navbar" className="navbar-landing">
          <div className="menus-wrapper row-landing gap-24-landing align-center-landing">
            <input
              id="hamburger-icon"
              className="checkbox-landing"
              type="checkbox"
              name=""
              hidden
            />
            <label htmlFor="hamburger-icon" className="hamburger-lines">
              <span className="line line1"></span>
              <span className="line line2"></span>
              <span className="line line3"></span>
            </label>
            <a href="/" className="logo-landing">
              <img
                src={images.zlogo}
                alt="Zynerd Logo"
                className="h-100-landing"
              />
            </a>
            <div
              className="menus"
              ref={(el) => (menusRef.current = [...menusRef.current, el])}
            >
              <div className="center">
                {/* Exams Dropdown */}
                <div className="menu exams-main">
                  <a className="menu-link row-landing gap-4-landing align-end-landing">
                    Exams
                    <img
                      src={landingIcons.chevronDownMini}
                      alt=""
                      className="icon-landing"
                    />
                  </a>
                  <div className="menu-dropdown column-landing w-max-content-landing gap-8-landing px-40-landing py-40-landing rounded-lg bd-black bg-white hide-landing">
                    <a
                      href="/neet-ug"
                      className="dropdown-menu-item-landing row-landing align-center-landing"
                    >
                      <div className="exam-sticker-landing fs-40 fw-black bg-blue-landing shadow-landing">
                        UG
                      </div>
                      <div className="column-landing gap-4-landing px-24-landing">
                        <div className="fs-24 fw-bold">Under Graduate</div>
                        <div className="fs-12 fw-bold">
                          IN 30 STATES & ALL INDIA COUNSELLING
                        </div>
                      </div>
                    </a>
                    <a
                      href="/neet-pg"
                      className="dropdown-menu-item-landing row-landing px-4-landing align-center-landing"
                    >
                      <div className="exam-sticker-landing fs-40 fw-black bg-orange-landing shadow-landing">
                        PG
                      </div>
                      <div className="column-landing px-24-landing gap-4-landing">
                        <div className="fs-24 fw-bold">Post Graduate</div>
                        <div className="fs-12 fw-bold">
                          IN 30 STATES & ALL INDIA COUNSELLING
                        </div>
                      </div>
                    </a>
                  </div>
                </div>

                {/* Resources Dropdown */}
                <div className="menu resources-main">
                  <a className="menu-link row-landing gap-4-landing align-end-landing">
                    Resources
                    <img
                      src={landingIcons.chevronDownMini}
                      alt=""
                      className="icon-landing"
                    />
                  </a>
                  <div className="menu-dropdown column-landing w-max-content-landing gap-8-landing px-40-landing py-40-landing rounded-lg bd-black bg-white add-nav-bar hide-landing">
                    <a
                      href="/neet-counselling-process"
                      className="dropdown-menu-item-landing row-landing"
                    >
                      <div className="fs-24 fw-bold">
                        NEET Counselling Process
                      </div>
                    </a>
                    <a
                      href="/top-colleges-for-neet"
                      className="dropdown-menu-item-landing row-landing"
                    >
                      <div className="fs-24 fw-bold">Top Colleges for Neet</div>
                    </a>
                    <a
                      href="/neet-ug-counselling-date"
                      className="dropdown-menu-item-landing row-landing"
                    >
                      <div className="fs-24 fw-bold">
                        NEET UG Counselling Date
                      </div>
                    </a>
                    <a
                      href="/neet-cut-off"
                      className="dropdown-menu-item-landing row-landing"
                    >
                      <div className="fs-24 fw-bold">NEET cut-off</div>
                    </a>
                    <a
                      href="/neet-subject"
                      className="dropdown-menu-item-landing row-landing"
                    >
                      <div className="fs-24 fw-bold">NEET 2024 Subject</div>
                    </a>
                  </div>
                </div>

                {/* Newsfeed Dropdown */}
                <div className="menu newsfeed-main">
                  <a className="menu-link row-landing gap-4-landing align-end-landing">
                    Newsfeed
                    <img
                      src={landingIcons.chevronDownMini}
                      alt=""
                      className="icon-landing"
                    />
                  </a>
                  <div className="menu-dropdown column-landing w-max-content-landing gap-8-landing px-40-landing py-40-landing rounded-lg bd-black bg-white add-nav-bar2 hide-landing">
                    <a
                      href="https://blog.zynerd.com"
                      className="dropdown-menu-item-landing row-landing"
                    >
                      <div className="fs-24 fw-bold">Blogs</div>
                    </a>
                    <a
                      href="https://blog.zynerd.com/news/"
                      className="dropdown-menu-item-landing row-landing"
                    >
                      <div className="fs-24 fw-bold">News</div>
                    </a>
                  </div>
                </div>

                <div className="menu">
                  <a href="/careers" className="menu-link">
                    Careers
                  </a>
                </div>

                {/* <div class="menu predictor-menu">
                      <a href="https://portal.zynerd.com/neet-college-predictor/neet-college-predictor-2024" class="menu-link">College Predictor
                      <span class="pill" style="background-color: #F85D05!important; border-radius: 6px; color:white; font-size: 10px; font-weight:bold;  padding: 3px; height: 18px;  margin-left: 4px;" >
                        NEW
                      </span>
                      </a>
                    </div>  */}

                {/* <div class="menu">
                      <a href="videos" class="menu-link">Videos</a>
                    </div> */}
              </div>
              <div className="right">
                {/* <div class="menu">
                      <a href="about" class="menu-link">About</a>
                    </div>  */}
              </div>
            </div>
          </div>

          <a
            href="/portal/dashboard"
            target="_blank"
            className="signin-signup-landing button button-black"
          >
            Sign in <span className="signup-text-landing"> / Sign up </span>
          </a>
        </nav>
      </header>
      {/* <div
        id="headerNavBar"
        className={`${styles.fixPos} border-b border-[#D9D9D9] items-center`}
      >
        <div
          className={`bg-white flex justify-between w-full  px-[8px] py-[6px] sm:px-[20px] sm:py-[8px]`}
        >
          <a href="https://www.zynerd.com/" className={styles.logo}>
            <img src={images.zlogo} className={styles.zlogo} />
          </a>
          <div className="flex justify-content-end gap-2 w-full justify-end">
            <div className="flex items-center gap-[4px]">
              <a
                href="https://www.zynerd.com/contact-us"
                target="_blank"
                className={` p-0  min-w-fit hover:bg-[#F0F0F0] text-black cursor-pointer px-1 2sm:!px-4 !py-[8px] rounded-[4px] overflow-hidden flex justify-center items-center`}
              >
                <label className="text-[14px] md:!text-[18px] cursor-pointer !font-bold  leading-[18px]">
                  Contact Us
                </label>
              </a>
            </div>
          </div>
        </div>
        <a
          href="https://portal.zynerd.com/"
          target="_blank"
          className={`${styles.signinSignup} ${styles.signinSignupButton} rounded-lg items-center`}
        >
          Sign in <span className={styles.spanUpText}> / Sign up </span>
        </a>
      </div> */}
    </>
  );
}
